import { useCallback } from 'react';
// @ts-expect-error js module
import usePermissionsContext from 'customer-data-sidebar/public/usePermissionsContext';
export function useGetHasScope() {
  const {
    scopes
  } = usePermissionsContext();
  return useCallback(scopeName => scopes.includes(scopeName), [scopes]);
}